import { getView, requireAuth } from '@/lib/utils';
import { AssetsPage } from '@/data/appInformationItems';
import { Left } from 'Models/Menu/menus';

export default {
  path: '/analytics',
  component: getView('pages/PagePerformance'),
  name: 'analytics',
  beforeEnter: requireAuth,
  meta: {
    crumbs: 'Analytics',
    leftMenu: Left.AnalyticsPage,
    roles: ['operator'],
    information: AssetsPage,
    showBottomMenu: true,
    isFlowChem: false,
    crumbsIcon: 'flow-analytics',

  },
};
